import { render, staticRenderFns } from "./itDeclarationStatmentOldRegimePopup.vue?vue&type=template&id=12ed0656&scoped=true"
import script from "./itDeclarationStatmentOldRegimePopup.vue?vue&type=script&lang=js"
export * from "./itDeclarationStatmentOldRegimePopup.vue?vue&type=script&lang=js"
import style0 from "./itDeclarationStatmentOldRegimePopup.vue?vue&type=style&index=0&id=12ed0656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed0656",
  null
  
)

export default component.exports